import React from 'react';
import Translation from '@src/js/Components/Base/Translation';
import style from '@src/js/Style';

export default class Article extends React.Component {

    constructor(props) {

        super(props);

        this.activeButton = false;
        this.state = {
            counter: this.getCounterValues(),
            loading: false,
        };
    }

    /**
     * Generate unique id per site page
     */
    getCounterId() {

        return ['reaction', 'article', window.location.pathname].join(':');
    }

    /**
     * Get counter values from storage
     * or returns zero values with async load real data
     */
    getCounterValues() {

        const
            counterId = this.getCounterId(),
            valueFromStorage = sessionStorage.getItem(counterId);

        if (valueFromStorage != undefined)
            return JSON.parse(valueFromStorage);

        this.asyncUpdateRequired = true;

        return { like: 0, dislike: 0 };

    }

    /**
     * Save counter values to storage
     * @param {object} counter
     */
    updateCounter(counter) {

        sessionStorage.setItem(this.getCounterId(), JSON.stringify(counter));
        this.setState({
            counter,
            loading: false,
        });

        if (counter?.userVariant) {

            const body = new FormData();
            body.append('url', window.location.pathname);
            body.append('type', counter.userVariant);

            fetch(`${window.location.origin}/api/v2/reaction/article.json?url=${window.location.pathname}`, {
                method: 'POST',
                body,
            });
        }
    }

    componentDidMount() {

        if (this.asyncUpdateRequired)
            this.asyncUpdateCounter();
    }

    /**
     * Async request to api and update counter
     */
    asyncUpdateCounter() {

        this.setState({ loading: true });

        fetch(`${window.location.origin}/api/v2/reaction/article.json?url=${window.location.pathname}`)
            .then((response) => response.json())
            .then((response) => {

                this.updateCounter({
                    like: response.context.likes,
                    dislike: response.context.dislikes,
                });
            });
    }

    render() {

        return (
            <div className={ style('w-full') } ref={ (node) => { this.node = node; } }>
                <hr className={ style('linebreak mt-4 mb-8') } />
                <Translation htmlTag='div' className={ style('title3') } tag='blog.post.rate-title' />
                <div className={ style('flex flex-wrap items-center gap-lg mt-4') }>
                    { this.getHtmlButton('icon-thumb-up', 'success', 'like', 0) }
                    { this.getHtmlButton('icon-thumb-down', 'danger', 'dislike', 0) }
                </div>
                <hr className={ style('linebreak mt-8 mb-4') } />
            </div>
        );
    }

    getHtmlButton(icon, color, type) {

        const
            toggleColor = style(`re-text-${color}`),
            activeClass = this.state.counter?.userVariant == type ? toggleColor : '';

        return (
            <div
                data-role='button'
                data-toggle-type={ type }
                data-toggle-color={ toggleColor }
                onClick={ (e) => this.toggleReaction(e, type) }
                className={ `${style('flex-center gap cursor-pointer text-gray-light')} ${activeClass}`.trim() }>

                <i className={ style(`title1 ${icon}`) }></i>

                <Translation
                    className={ style('title2 whitespace-nowrap mobile:hidden') }
                    tag={ `blog.post.rate-${type}` } />

                {/* eslint-disable-next-line max-len */}
                <div className={ style(`title3 bg-${color}-light text-${color} size-48 aspect-square rounded-full flex-center`) }>
                    { this.state.counter[type] }
                </div>

            </div>
        );
    }

    getActiveButton() {

        if (this.activeButton === false && this.state.counter?.userVariant)
            this.activeButton = this.node.querySelector(`[data-toggle-type="${this.state.counter.userVariant}"]`);

        return this.activeButton;
    }

    /**
     * Toggler button click action
     * @param {SyntheticEvent} e
     * @param {string} type
     */
    toggleReaction(e, type) {

        if (this.state.loading)
            return;

        const
            { nativeEvent } = e,
            { counter } = this.state,
            activeButton = this.getActiveButton(),
            clickedButton = (nativeEvent.target.dataset.role == 'button')
                ? nativeEvent.target
                : nativeEvent.target.closest('[data-role="button"]');

        if (clickedButton != activeButton) {

            // clicked to another button

            if (activeButton) {
                activeButton.classList.remove(activeButton.dataset.toggleColor);

                counter['like']--;
                counter['dislike']--;
                counter[type] += 2;
                // 2 is deselect hack
            }
            else {

                counter[type]++;
            }

            counter.userVariant = type;

            clickedButton.classList.add(clickedButton.dataset.toggleColor);
            this.activeButton = clickedButton;
        }
        else {

            // clicked to active button

            clickedButton.classList.toggle(clickedButton.dataset.toggleColor);
            counter[type] += (clickedButton.classList.contains(clickedButton.dataset.toggleColor)) ? 1 : -1;
            counter.userVariant = (clickedButton.classList.contains(clickedButton.dataset.toggleColor)) ? type : null;
        }

        this.updateCounter(counter);
        // update counter
    }

}